var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorGeneral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 108,
    viewBox: "0 0 137 108",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.6933 106.491C93.6933 106.491 116.393 83.7908 116.393 55.6908C116.393 27.5907 93.5933 4.89075 65.6933 4.89075C37.6933 4.89075 14.9933 27.5907 14.9933 55.6908C14.9933 83.7908 37.6933 106.491 65.6933 106.491Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.093 22.3908C115.358 22.3908 117.193 20.5552 117.193 18.2908C117.193 16.0264 115.358 14.1908 113.093 14.1908C110.829 14.1908 108.993 16.0264 108.993 18.2908C108.993 20.5552 110.829 22.3908 113.093 22.3908Z",
    fill: "#F1F3F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.093 6.39077C120.64 6.39077 121.893 5.13717 121.893 3.59077C121.893 2.04437 120.64 0.790771 119.093 0.790771C117.547 0.790771 116.293 2.04437 116.293 3.59077C116.293 5.13717 117.547 6.39077 119.093 6.39077Z",
    fill: "#F1F3F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6933 22.2908C19.2397 22.2908 20.4933 21.0372 20.4933 19.4908C20.4933 17.9444 19.2397 16.6908 17.6933 16.6908C16.1469 16.6908 14.8933 17.9444 14.8933 19.4908C14.8933 21.0372 16.1469 22.2908 17.6933 22.2908Z",
    fill: "#F1F3F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9113 82.8188C8.78318 82.8188 11.1113 80.4907 11.1113 77.6188C11.1113 74.7469 8.78318 72.4188 5.9113 72.4188C3.03942 72.4188 0.711304 74.7469 0.711304 77.6188C0.711304 80.4907 3.03942 82.8188 5.9113 82.8188Z",
    fill: "#F1F3F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M136.233 94.1081C136.16 96.5767 133.982 98.4644 131.514 98.4644H99.5669C98.4052 98.4644 97.4614 99.3357 97.3888 100.425C97.3162 101.659 98.26 102.603 99.4943 102.603H107.626C108.134 102.603 108.57 103.039 108.57 103.547C108.57 104.055 108.134 104.491 107.626 104.491H59.7062C57.2376 104.491 55.1321 102.603 54.9868 100.134C54.9142 97.5932 56.9472 95.4876 59.4884 95.4876H66.5312C67.5477 95.3424 68.419 94.4711 68.419 93.382C68.419 92.2203 67.4751 91.2764 66.3134 91.2764H44.6768C41.0465 91.2764 37.9244 88.59 37.7066 84.9597C37.4162 81.039 40.5382 77.7717 44.459 77.7717H108.207C111.91 77.7717 114.959 80.8212 114.959 84.5241C114.959 86.1214 114.379 87.5735 113.507 88.7352C113.943 88.9531 114.306 89.1709 114.669 89.4613H131.949C134.273 89.5339 136.306 91.5669 136.233 94.1081Z",
    fill: "#9FA8BA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7116 31.1028L69.6162 34.8057L37.597 41.0498L23.5114 43.8088C20.9702 44.3171 19.2277 46.6405 19.4455 49.2543L22.2045 80.1118C22.4223 82.6531 24.6005 84.686 27.1417 84.686L93.5762 85.4847L88.7116 31.1028Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6255 33.2812L101.054 81.9998C101.054 82.3629 100.837 82.7259 100.474 82.7985L95.1734 83.9602L90.454 32.4099L95.8994 32.5551C96.2625 32.5551 96.5529 32.9182 96.6255 33.2812Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5004 29.2151L89.8732 88.1712C89.9458 88.6068 90.3815 88.8972 90.7445 88.6794L95.9721 86.6465C96.6256 86.356 97.0612 85.63 96.9886 84.9039L92.124 30.9576C92.0514 30.2316 91.5432 29.6507 90.8171 29.4329L85.299 28.489C84.8634 28.4164 84.5004 28.7795 84.5004 29.2151Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3423 34.7332L38.3231 40.9773C37.96 42.7198 37.8148 44.4624 38.0326 46.2775C38.9039 56.0793 47.544 63.2673 57.2732 62.396C67.0024 61.5248 74.1904 52.8847 73.3192 43.1555C73.0287 40.0334 72.0123 37.2018 70.3423 34.7332Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorGeneral);
export default __webpack_public_path__ + "static/media/error-general.0cff1fc47d4759624e229e0b8162abe8.svg";
export { ForwardRef as ReactComponent };